module.exports = __webpack_public_path__ + "static/media/insta.8efa5a6c.svg";